import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom"; // Importa useNavigate
import "../../css/ColorTable.css"; // Importa el archivo CSS
import { obtenerListaEmpresas } from "../../../store/Empresa/thunkEmpresa";
import CircularProgress from "@mui/material/CircularProgress"; // Si usas MUI para el loader, ajusta según tu librería

export const ListaEmpresa = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate(); // Inicializa useNavigate para navegar a otras rutas
    const [Empresas, setEmpresas] = useState([]);
    const [loading, setLoading] = useState(true); // Estado para manejar el loading
    const [currentPage, setCurrentPage] = useState(1); // Estado para la página actual
    const [clientsPerPage, setClientsPerPage] = useState(10); // Estado para el número de empresas por página
    const [searchTerm, setSearchTerm] = useState(""); // Estado para el filtro de búsqueda por nombre
    const [statusFilter, setStatusFilter] = useState(""); // Estado para el filtro por estado (activo/inactivo)

    useEffect(() => {
        const fetchEmpresa = async () => {
            setLoading(true); // Inicia la carga
            const response = await dispatch(obtenerListaEmpresas());
            setEmpresas(response || []);
            setLoading(false); // Finaliza la carga
        };

        fetchEmpresa();
    }, [dispatch]);

    // Filtrar las empresas según el término de búsqueda y el estado
    const filteredEmpresas = Empresas.filter((empresa) => {
        const matchesName = empresa.nombre_empresa.toLowerCase().includes(searchTerm.toLowerCase());
        const matchesStatus = statusFilter === "" || empresa.estado_empresa === parseInt(statusFilter);
        return matchesName && matchesStatus;
    });

    // Calcular las empresas que se mostrarán en la página actual
    const indexOfLastEmpresa = currentPage * clientsPerPage;
    const indexOfFirstEmpresa = indexOfLastEmpresa - clientsPerPage;
    const currentEmpresas = filteredEmpresas.slice(indexOfFirstEmpresa, indexOfLastEmpresa);

    // Calcular el total de páginas
    const totalPages = Math.ceil(filteredEmpresas.length / clientsPerPage);

    // Función para cambiar la cantidad de empresas por página
    const handleClientsPerPageChange = (event) => {
        setClientsPerPage(Number(event.target.value));
        setCurrentPage(1); // Reiniciar a la primera página
    };

    // Funciones para cambiar de página
    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    // Manejar cambios en el término de búsqueda
    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
        setCurrentPage(1); // Reiniciar a la primera página
    };

    // Manejar cambios en el filtro de estado
    const handleStatusFilterChange = (event) => {
        setStatusFilter(event.target.value);
        setCurrentPage(1); // Reiniciar a la primera página
    };

    // Función para redirigir al perfil de la empresa seleccionada
    const handleRowClick = (idEmpresa) => {
        navigate(`/empresas/perfil?data=${idEmpresa}`);
    };

    return (
        <>
            {loading ? (
                <div className="preload-container" style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
                    <CircularProgress /> {/* Loader de material UI, si usas otro, cámbialo */}
                </div>
            ) : (
                <>
                    <div className="row">
                        <div className="col-md-4 mb-2">
                            <input type="text" placeholder="Buscar por nombre" className="form-control" value={searchTerm} onChange={handleSearchChange} />
                        </div>
                        <div className="col-md-4 mb-2">
                            <select className="form-select" value={statusFilter} onChange={handleStatusFilterChange}>
                                <option value="">Todos</option>
                                <option value="1">Activos</option>
                                <option value="0">Inactivos</option>
                            </select>
                        </div>
                        <div className="col-md-4 mb-2">
                            <select id="clientsPerPage" className="form-select" value={clientsPerPage} onChange={handleClientsPerPageChange} style={{ width: "100px" }}>
                                <option value={10}>10</option>
                                <option value={20}>20</option>
                                <option value={30}>30</option>
                                <option value={50}>50</option>
                                <option value={70}>70</option>
                                <option value={100}>100</option>
                            </select>
                        </div>
                    </div>

                    <div className="table-responsive">
                        <table className="table table-striped table dt-responsive w-100 display text-left hoverable-table" style={{ fontSize: "15px", width: "100%", textAlign: "left" }}>
                            <thead>
                                <tr>
                                    <th>Nombre Empresa</th>
                                    <th>Estado</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentEmpresas.length === 0 ? (
                                    <tr>
                                        <td colSpan="2" style={{ textAlign: "center" }}>
                                            No hay empresas disponibles
                                        </td>
                                    </tr>
                                ) : (
                                    currentEmpresas.map((empresa) => (
                                        <tr key={empresa.id_empresa} onClick={() => handleRowClick(empresa.id_empresa)} style={{ cursor: "pointer" }}>
                                            <td>{empresa.nombre_empresa || "SIN NOMBRE"}</td>
                                            <td>{empresa.estado_empresa === 1 ? "Activo" : "Inactivo"}</td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>

                    <div className="pagination-controls" style={{ textAlign: "center", marginTop: "20px" }}>
                        <button onClick={handlePrevPage} disabled={currentPage === 1} className="btn btn-light">
                            Anterior
                        </button>
                        <span style={{ margin: "0 10px" }}>
                            Página {currentPage} de {totalPages}
                        </span>
                        <button onClick={handleNextPage} disabled={currentPage === totalPages} className="btn btn-light">
                            Siguiente
                        </button>
                    </div>
                </>
            )}
        </>
    );
};
